/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

export const apiConfig = {
  // baseURL: "http://localhost:3004/dev",
  baseURL: "https://8sg3vkxty8.execute-api.us-east-1.amazonaws.com/dev",
};
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: "9a20de63-834b-477e-a8df-3d522ed7c161", // This is the ONLY mandatory field that you need to supply.
    authority:
      "https://login.microsoftonline.com/ac821c27-15ae-40ac-bb34-475594b0cb72/oauth2/v1.0/authorize", // Defaults to "https://login.microsoftonline.com/common"
    // redirectUri: "http://localhost:3000", // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    redirectUri: "https://multicloud.seidorcloud.com.br", // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
    clientCapabilities: ["CP1"], // this  lets the resource owner know that this client is capable of handling claims challenge.
  },
  cache: {
    cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  users: {
    adUsersListEndpoint: `${apiConfig.baseURL}/users/ad`,
    disableAdUsersEndpoint: `${apiConfig.baseURL}/users/ad`,
    resetAdUsersPassword: `${apiConfig.baseURL}/users/ad/password`,
    activeUsersListEndpoint: `${apiConfig.baseURL}/users/active`,
    kickActiveUserEndpoint: `${apiConfig.baseURL}/users/active`,
    dashboardEndpoint: `${apiConfig.baseURL}`,
    activeUsers: `${apiConfig.baseURL}`,
    scopes: [
      "api://9a20de63-834b-477e-a8df-3d522ed7c161/Administrator.access",
      "email",
    ],
    // scopes: ["openid", "profile", "offline_access", "User.Read"],
    // scopes: ["user.read"],
  },
  approvals: {
    approvalsListEndpoint: `${apiConfig.baseURL}/approvals`,
    changesListEndpoint: `${apiConfig.baseURL}/changes`,
    allChangesListEndpoint: `${apiConfig.baseURL}/changesById`,
    approvalListByIdEndpoint: `${apiConfig.baseURL}/gmuds`,
    gmudReproveEndpoint: `${apiConfig.baseURL}/approvals`,
  },
  logs: {
    getLogsEndpoint: `${apiConfig.baseURL}/logs`,
  },
  company: {
    getCompaniesEndpoint: `${apiConfig.baseURL}/companies`,
    getIntegrationCompaniesEndpoint: `${apiConfig.baseURL}/integration/companies`,
    getCompanyByIdEndpoint: `${apiConfig.baseURL}/company`,
    createOrUpdateCompanyEndpoint: `${apiConfig.baseURL}/company`,
    deleteCompanyEndpoint: `${apiConfig.baseURL}/company/`,
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [...protectedResources.users.scopes],
  // scopes: [],
};

export const makeLoginRequest = {
  // scopes: [...protectedResources.users.scopes],
  scopes: [],
};

export const companyRoles = {
  seidor: "seidor",
};

export const appRoles = {
  ListActiveUsers: "list.active.users",
  ListADUsers: "list.ad.users",
  ListApprovalClients: "list.approval.clients",
  ListCompany: "list.company",
  SysAdministrator: "all.access",
  KickActiveUser: "list.active.users",
  DisableADUser: "list.ad.users",
};

export const protectedPages = {
  listActiveUsersPage: {
    label: "Usuários conectados",
    path: "/users/active",
    roles: [appRoles.SysAdministrator, appRoles.ListActiveUsers],
  },
  listADUsersPage: {
    label: "Gestão de usuários",
    path: "/users/ad",
    roles: [appRoles.SysAdministrator, appRoles.ListADUsers],
  },
  listCompaniesPage: {
    label: "Empresas",
    path: "/companies",
    roles: [appRoles.SysAdministrator, appRoles.ListCompany],
  },
  changesClientsPage: {
    label: "Mudanças",
    path: "/changes",
    roles: [appRoles.SysAdministrator, appRoles.ListApprovalClients],
  },
  approvalClientsPage: {
    label: "Aprovação",
    path: "/approval",
    roles: [appRoles.SysAdministrator, appRoles.ListApprovalClients],
  },
  listLogsPage: {
    label: "Logs",
    path: "/logs",
    roles: [appRoles.SysAdministrator],
  },
};
